import React from 'react';
import PageAncestor from 'core/common/page/pageAncestor';
import gridService from 'core/grid/gridService';
import GridCompConnected from 'core/grid/component/gridCompConnected';
import {MODULE, PageProps} from "core/metamodel/metaConstant";
import mdEntityService from "core/metamodel/mdEntityService";
import {observer} from "mobx-react";
import {loc} from "../../../core/common/config/locales";
import {ENERGY_CARRIERS_LIST} from "../../gridsContants";

@observer
export default class EnergyCarriersList extends PageAncestor<PageProps, undefined> {

  static module = MODULE.sbtool;
  static title = loc.i18n`Energy carriers`;
  static icon = 'building-o';
  static rootPage = true;
  static protectedPage = true;


  static fetchData(routerParams) {
    console.log("EnergyCarriersList#fetchData(%s)", ENERGY_CARRIERS_LIST);

    return gridService.fetchGrids(ENERGY_CARRIERS_LIST)
      .then(gridLocationMap => {
        return gridService.getOrCreateGrid(ENERGY_CARRIERS_LIST);
      });
  }

  render() {
    let { params, query } = this.props;
    return (
      <GridCompConnected grid={gridService.getOrCreateGrid(ENERGY_CARRIERS_LIST)} entities={mdEntityService.entityMap} gridId={params.gridId} query={query}/>
    );
  }


}



// WEBPACK FOOTER //
// ./src/sbtool/page/material/energyCarriersList.tsx